import { Home, Mail, Phone } from "lucide-react";
import { SERVICE_STATES } from "@/constants/states";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2C3D30] text-[#F1EDE7] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid gap-12 lg:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-xl bg-[#D95D39] flex items-center justify-center text-white">
              <Home strokeWidth={1.75} className="w-5 h-5" />
            </div>
            <div>
              <div className="font-[Outfit] font-semibold text-white text-lg">T&amp;R Capital LLC</div>
              <div className="text-xs uppercase tracking-[0.18em] text-[#F1EDE7]/70">Sell your home hassle free</div>
            </div>
          </div>
          <p className="text-sm text-[#F1EDE7]/80 leading-relaxed max-w-sm">
            We&apos;re a family-run cash home buying company helping homeowners sell quickly — without
            repairs, agents, or stress.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#F1EDE7]/60 mb-4">Service Areas</div>
          <div className="flex flex-wrap gap-2">
            {SERVICE_STATES.map((s) => (
              <span
                key={s.code}
                data-testid={`footer-state-${s.code}`}
                className="bg-white/10 text-[#F1EDE7] px-3 py-1.5 rounded-full text-xs"
              >
                {s.name}
              </span>
            ))}
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#F1EDE7]/60 mb-4">Get in Touch</div>
          <ul className="space-y-3 text-sm text-[#F1EDE7]/80">
            <li className="flex items-start gap-3">
              <Mail strokeWidth={1.5} className="w-4 h-4 text-[#D95D39] mt-0.5 shrink-0" />
              <span data-testid="footer-contact-note">
                Submit the form above — we&apos;ll reach out within 24 hours.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Phone strokeWidth={1.5} className="w-4 h-4 text-[#D95D39] mt-0.5 shrink-0" />
              <span data-testid="footer-phone-note">Prefer a phone call? Mention it in your note.</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#F1EDE7]/60">
          <div>© {new Date().getFullYear()} T&amp;R Capital LLC. All rights reserved.</div>
          <div>Cash buyer · As-Is condition · Close in 3 weeks or less</div>
        </div>
      </div>
    </footer>
  );
}
